import { ShieldCheck, CreditCard, Lock, BadgeCheck } from "lucide-react";

interface PaymentBadgeProps {
  delay?: number;
}

const PaymentBadge = ({ delay = 0 }: PaymentBadgeProps) => {
  return (
    <div
      className="group relative flex items-center gap-4 px-5 py-3.5 bg-card rounded-xl border border-primary/20 shadow-soft hover:shadow-badge hover:border-primary/40 transition-all duration-300 hover:-translate-y-1 animate-scale-in overflow-hidden"
      style={{ animationDelay: `${delay}ms` }}
    >
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-blue-500/30 opacity-50" />

      <div className="relative flex items-center gap-2">
        <div className="w-10 h-10 rounded-full gradient-primary flex items-center justify-center shadow-sm">
          <ShieldCheck className="w-5 h-5 text-primary-foreground" />
        </div>
        <div className="flex flex-col">
          <span className="font-bold text-foreground text-base">
            100% Secure
          </span>
          <span className="text-xs text-muted-foreground">SSL Encrypted</span>
        </div>
      </div>

      <div className="relative h-8 w-px bg-gradient-to-b from-transparent via-border to-transparent" />

      <div className="relative flex items-center gap-2">
        {[
          { icon: CreditCard, label: "Cards" },
          { icon: BadgeCheck, label: "UPI" },
          { icon: Lock, label: "Razorpay" },
        ].map((item, index) => (
          <div
            key={item.label}
            className="flex items-center gap-1.5 px-2.5 py-1.5 bg-muted/50 rounded-lg border border-border/50 hover:border-primary/30 hover:bg-blue-600 hover:text-emerald-50  transition-all duration-200"
          >
            <item.icon className="w-3.5 h-3.5 text-primary hover:text-white" />
            <span className="text-xs font-medium text-foreground">
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentBadge;
